import React from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

const DataDeliveryDoc = () => {
  const history = useHistory();

  const steps = [
    {
      title: 'Accessing Delivered Orders',
      intro: 'Once your order status changes to "Delivered," you can access and interact with your data.',
      points: [
        '• Navigate to the "Orders" tab from the navigation bar.',
        '• Locate your order marked as "Delivered" in the status column.',
        '• Click the Eye Icon to open the order details page.'
      ],
      image: '/images/delivered_orders.png'
    },
    {
      title: 'Previewing Imagery on the Map',
      intro: 'Visualize the delivered imagery directly on the interactive map.',
      points: [
        '• Preview selected images aligned with your AOI on the map.',
        '• Toggle visibility of specific images for better map analysis.',
        '• View metadata like capture date, cloud cover, resolution, and coverage %.'
      ],
      image: '/images/preview_on_map.png'
    },
    {
      title: 'Reviewing Image Details',
      intro: 'Get a complete breakdown of each delivered image or product.',
      points: [
        '• See information like Constellation, Resolution, Cloud Cover, Area Coverage.',
        '• Check Off-Nadir Angle, Capture Date, and Product ID.',
        '• Quickly assess the quality of delivered data before downloading.'
      ],
      image: '/images/image_details_table.png'
    },
    {
      title: 'Downloading Your Data Products',
      intro: 'Download final processed imagery and auxiliary files easily from the platform.',
      points: [
        '• Click the "Download" button available once an order is delivered.',
        '• Downloaded products are typically provided as .zip packages.',
        '• Ensure your selected format (e.g., GeoTIFF, JPEG) matches your analysis needs.',
        '• You can also download specific scenes individually if needed.'
      ],
      image: '/images/download_products.png'
    }
  ];

  return (
    <Box sx={{ maxWidth: '1000px', mx: 'auto', p: 4 }}>
      <Button startIcon={<ArrowBackIcon />} sx={{ mb: 4, color: '#1976d2' }} onClick={() => history.push("/documentation")}>
        Back to Documentation
      </Button>

      <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#1976d2' }}>
        Data Delivery - Previewing and Downloading Products
      </Typography>

      {steps.map((step, index) => (
        <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }} key={index}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ mb: 2, color: '#333', fontWeight: 600 }}>{`${index + 1}. ${step.title}`}</Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>{step.intro}</Typography>
              {step.points.map((point, idx) => (
                <Typography key={idx} variant="body2" color="text.secondary" sx={{ ml: 2, mb: 1 }}>{point}</Typography>
              ))}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={step.image}
                alt={step.title}
                sx={{ width: '100%', height: 'auto', borderRadius: 2, boxShadow: 3 }}
              />
            </Grid>
          </Grid>
        </Paper>
      ))}
    </Box>
  );
};

export default DataDeliveryDoc;